<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <!-- Basic Info Panel -->
        <v-col md="6" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Basic Info
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submitForm(currentStatus)" ref="costingForm">
                  <v-row class="pa-2">
                    <v-col cols="12" md="6">

                      <v-autocomplete
                        v-model="import_lc_shipment_id.value.value"
                        :items="getLcShipmentList"
                        :item-title="(item) => `LC No. ${item?.lc_master?.lc_no} - Shipment No. ${item.code}`"
                        item-value="id"
                        label="Select Shipment"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :error-messages="import_lc_shipment_id.errorMessage.value"
                        clearable
                        @update:model-value="onShipmentUpdate"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          LC & Shipment
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-date-input
                        v-model="date.value.value"
                        label="Costing Date"
                        input-format="dd/mm/yyyy"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-icon=""
                        :error-messages="date.errorMessage.value"
                        clearable
                      ></v-date-input>
                      
                      <!-- <v-autocomplete
                        v-model="lc_id.value.value"
                        :items="getLcImportLcMasterList"
                        item-title="code"
                        item-value="id"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        disabled
                        :error-messages="lc_id.errorMessage.value"
                        clearable
                        @update:model-value="onShipmentUpdate"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          LC 
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete> -->

                      <v-autocomplete
                        v-model="currency_id.value.value"
                        :items="getCurrencyList"
                        item-title="code"
                        item-value="id"
                        label="Currency"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :error-messages="currency_id.errorMessage.value"
                        readonly=""
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Currency
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-text-field
                        v-model="lc_value.value.value"
                        type="number"
                        step="0.01"
                        label="LC Value (USD)"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :error-messages="lc_value.errorMessage.value"
                        clearable
                        disabled
                        @update:model-value="calculateTotalExpanse"
                        >
                          <template #label>
                            LC Value (USD)
                            <span class="text-red-accent-4">*</span>
                          </template>
                      </v-text-field>                      
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-text-field
                          v-model="overhead_cost.value.value"
                          type="number"
                          label="Overhead Cost"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="overhead_cost.errorMessage.value"
                          clearable
                          @update:model-value="calculateTotalExpanse"
                        >
                          <template #label>
                            Overhead Percentage (%)
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="ait_percent.value.value"
                          type="number"
                          label="AIT Percentage"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="ait_percent.errorMessage.value"
                          clearable
                          @update:model-value="calculateTotalExpanse"
                        >
                          <template #label>
                            AIT Percentage (%)
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="vat_percent.value.value"
                          type="number"
                          label="VAT Percentage"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="vat_percent.errorMessage.value"
                          clearable
                          @update:model-value="calculateTotalExpanse"
                        >
                          <template #label>
                            VAT Percentage (%)
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="profit_percent.value.value"
                          type="number"
                          label="Profit Percentage"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="profit_percent.errorMessage.value"
                          clearable
                          @update:model-value="calculateTotalExpanse"
                        >
                          <template #label>
                            Profit Percentage (%)
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="conversion_rate.value.value"
                          type="number"
                          step="0.01"
                          label="Conversion Rate"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="conversion_rate.errorMessage.value"
                          clearable
                          @update:model-value="calculateTotalExpanse"
                        >
                          <template #label>
                            Conversion Rate(TK)
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>


                        <v-text-field
                          v-model="lc_value_bdt.value.value"
                          type="number"
                          step="0.01"
                          label="LC Value (BDT)"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="lc_value_bdt.errorMessage.value"
                          clearable
                          disabled
                          @update:model-value="calculateTotalExpanse"
                        >
                          <template #label>
                            LC Value (BDT)
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>

                      </v-col>

                      <v-col cols="12">
                        <v-textarea
                          v-model="remarks.value.value"
                          label="Remarks"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          rows="3"
                          
                          clearable
                        ></v-textarea>
                    </v-col>
                     
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="6" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Other Expense
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submitForm(currentStatus)" ref="costingForm">
                  
                  <v-row class="pa-2">
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="lc_issue_charge.value.value"
                        type="number"
                        step="0.01"
                        label="Lc Issue Charge"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :error-messages="lc_issue_charge.errorMessage.value"
                        clearable
                        
                        @update:model-value="calculateTotalExpanse"
                      >
                      </v-text-field>

                      <v-checkbox
                        v-model="is_freight_charge_auto"
                        label="Auto Calculate Freight charge"
                        density="compact"
                        
                      ></v-checkbox>
                        
                      <v-text-field
                          v-model="freight_charge.value.value"
                          type="number"
                        step="0.01"
                        label="Freight Charge"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :error-messages="freight_charge.errorMessage.value"
                        clearable
                        
                        @update:model-value="calculateTotalExpanse"
                      >
                      </v-text-field>

                      <v-text-field
                          v-model="c_and_f_expanse.value.value"
                          type="number"
                          step="0.01"
                          label="C & F Expenses"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="c_and_f_expanse.errorMessage.value"
                          clearable
                          
                          @update:model-value="calculateTotalExpanse"
                        >
                        </v-text-field>

                        <v-text-field
                          v-model="global_taxes.value.value"
                          type="number"
                          step="0.01"
                          label="Global Taxes"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="global_taxes.errorMessage.value"
                          clearable
                          
                          @update:model-value="calculateTotalExpanse"
                        >
                        </v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="6">
                        <v-text-field
                          v-model="insurance.value.value"
                          type="number"
                          step="0.01"
                          label="Insurance"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="insurance.errorMessage.value"
                          clearable
                          
                          @update:model-value="calculateTotalExpanse"
                        >
                        </v-text-field>

                        <v-text-field
                          class="mt-9"
                          v-model="transportation_cost.value.value"
                          type="number"
                          step="0.01"
                          label="Transportation"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="transportation_cost.errorMessage.value"
                          clearable
                          
                          @update:model-value="calculateTotalExpanse"
                        >
                        </v-text-field>

                        <v-text-field
                          v-model="customs_duty.value.value"
                          type="number"
                          step="0.01"
                          label="Customs Duty"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="customs_duty.errorMessage.value"
                          clearable
                          
                          @update:model-value="calculateTotalExpanse"
                        >
                        </v-text-field>

                    </v-col>
                    
                    <v-col cols="12" md="6" >
                        <v-text-field
                          v-model="total_other_expanse.value.value"
                          type="number"
                          step="0.01"
                          label="Total Other Expenses"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="total_other_expanse.errorMessage.value"
                          @update:model-value="calculateTotalExpanse"
                          readonly
                          disabled
                        >
                        </v-text-field>
                        <v-text-field
                          v-model="total_qty.value.value"
                          type="number"
                          step="0.01"
                          label="Total Quantity(KGs)"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="total_qty.errorMessage.value"
                          @update:model-value="calculateTotalExpanse"
                          readonly
                          disabled
                        >
                        </v-text-field>
                    </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="total_expanse.value.value"
                          type="number"
                          step="0.01"
                          label="Total Expanse"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="total_expanse.errorMessage.value"
                          @update:model-value="calculateTotalExpanse"
                          readonly
                          disabled
                          
                        >
                        </v-text-field>

                        <v-text-field
                          v-model="total_lc_value.value.value"
                          type="number"
                          step="0.01"
                          label="Total LC Value"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="total_lc_value.errorMessage.value"
                          @update:model-value="calculateTotalExpanse"
                          readonly
                          disabled
                          
                        >
                        </v-text-field>
                    </v-col>
                  </v-row>
                
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- Costing Details Panel -->
        <v-col md="12" cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Costing Details
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submitForm(currentStatus)" ref="costingForm">
                  <v-row>
                    <v-col cols="12">
                      <v-table dense class="mt-3 elevation-1 no-wrap-table " height="400px" >
                        <thead>
                          <tr>
                            <th class="">Product</th>
                            <th>HS code</th>
                            <th>Qty(KGs)</th>
                            <th>Rate/KG (PI) {{ currency }}</th>
                            <th>Total Value {{ currency }}</th>
                            <th>Value in TK</th>
                            <th>LC Issue Charge</th>
                            <th>Freight Charge</th>
                            <th>Custom Duty</th>
                            <th>Global Taxes</th>
                            <th>Insurance</th>
                            <th>Transportation</th>
                            <th>C & F Expense</th>
                            <th>LC Cost / Kg</th>
                            <th>Landed Cost / Kg</th>
                            <th>Overhead Cost / Kg</th>
                            <th>Product Cost / Kg</th>
                            <th>Profit /KG</th>
                            <th>Sales Price</th>
                            <th>AIT /KG</th>
                            <th>Price with ait</th>
                            <th>VAT /KG</th>
                            <th>With VAT</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in details" :key="index">
                            <td style="padding: 2px;"> <v-autocomplete style="width: 200px;"  v-model="item.product_id" :items="getProductMapList" :item-title="(item) => `${item?.product?.code}-${item?.product?.name}` ?? 'N/A'" item-value="product_id"  density="compact"  variant="outlined" clearable readonly disabled  :menu-props="{ contentClass: 'my-custom-dropdown' }"></v-autocomplete></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.hs_code" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.qty" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.rate" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.total_value" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.value_in_tk" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  readonly disabled style="width: 200px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.lc_issue_charge" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  readonly disabled style="width: 200px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.freight_charge" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.custom_duty" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.global_taxes" disabled @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.insurance" disabled @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.transportation" disabled @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.c_and_f_expense" disabled @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.lc_cost_per_kg" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.landed_cost_per_kg" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.overhead_cost_per_kg" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.product_cost_per_kg" @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.profit_per_kg" disabled @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined" :max="100"  style="width:100px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.sales_price" disabled @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined" :max="100"  style="width:100px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.ait_per_kg" disabled @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined" :max="100"  style="width:100px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.price_with_ait" disabled @update:model-value="calculateTotalExpanse" type="number" density="compact" variant="outlined" :max="100"  style="width:100px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.vat_per_kg" type="number" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.with_vat" type="number" density="compact" variant="outlined"  readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-btn icon color="red" @click="removeDetailRow(index)"> <v-icon>mdi-delete</v-icon> </v-btn></td>
                          </tr>
                          <tr>
                            <td colspan="2" class="text-right text-bold">Total</td>
                            <td><v-text-field v-model="total_qty_kgs" readonly disabled /></td>
                            <td></td>
                            <td><v-text-field v-model="total_value_gbp" readonly disabled /></td>
                            <td><v-text-field v-model="total_value_in_tk" readonly disabled /></td>
                            <td><v-text-field v-model="total_lc_issue_charge" readonly disabled /></td>
                            <td><v-text-field v-model="total_freight_charge" readonly disabled /></td>
                            <td><v-text-field v-model="total_custom_duty" readonly disabled /></td>
                            <td><v-text-field v-model="total_global_taxes" readonly disabled /></td>
                            <td><v-text-field v-model="total_insurance" readonly disabled /></td>
                            <td><v-text-field v-model="total_transportation_cost" readonly disabled /></td>
                            <td><v-text-field v-model="total_c_and_f_expanse" readonly disabled /></td>
                            <td><v-text-field v-model="total_lc_cost_per_kg" readonly disabled /></td>
                            <td><v-text-field v-model="total_landed_cost" readonly disabled /></td>
                            <td><v-text-field v-model="total_overhead" readonly disabled/></td>
                            <td><v-text-field v-model="total_product_cost" readonly disabled/></td>
                            <td><v-text-field v-model="total_profit" readonly disabled/></td>
                            <td><v-text-field v-model="total_sales_price" readonly disabled/></td>
                            <td><v-text-field v-model="total_ait" readonly disabled/></td>
                            <td><v-text-field v-model="total_price_with_ait" readonly disabled /></td>
                            <td><v-text-field v-model="total_vat" readonly disabled /></td>
                            <td><v-text-field v-model="total_with_vat" readonly disabled /></td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-col>
                  </v-row>

                  <v-row class="pt-4">
                    <v-col cols="12" class="d-flex justify-end" style="gap: 12px;">
                      <v-btn class="bg-grey-darken-1" @click="submitForm(0)">DRAFT</v-btn>
                      <v-btn class="bg-primary" @click="submitForm(1)">POST</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";


const panel = ref([0]);
const panel1 = ref([0]);
const store = useStore();
const router = useRouter();
const route = useRoute();

const branchId = computed(() => { return store.getters.getAuthUser?.branch_id || null;});
const getCurrencyList = computed(() => {return store.getters.getCurrencyList || [];});
const getLcImportLcMasterList = computed(() => { return store.getters.getLcImportLcMasterList || []; });

console.log(getLcImportLcMasterList.value)

const getProductMapList = computed(() => {
  let products = store.getters.getProductMapList || [];
  return products.filter(
    (item) => item.branch_id == branchId.value && item.status == 1
  );
});

const { handleSubmit } = useForm({
  validationSchema: yup.object({
    import_lc_shipment_id: yup.number().required().label("Shipment"),
    currency_id: yup.number().required().label("Currency"),
    conversion_rate: yup.number().required().min(0).label("Conversion Rate"),

    // details: yup.array().of(
    //   yup.object().shape({
    //     product_id: yup.number().required("Product is required"),
    //     qty: yup.number().required("Qty is required").min(0),
    //     rate: yup.number().required("Rate is required").min(0),
    //     total_value: yup.number().required().min(0),
    //     value_in_tk: yup.number().required().min(0),
    //     duty_ind_bc_charge_percent: yup.number().required().min(0),
    //     duty_ind_bc_charge: yup.number().required().min(0),
    //     freight_charge: yup.number().required().min(0),
    //     lc_cost_per_kg: yup.number().required().min(0),
    //     profit_per_kg: yup.number().required().min(0),
    //     profit: yup.number().required().min(0),
    //     ait_percent: yup.number().required().min(0),
    //     ait: yup.number().required().min(0),
    //     vatable_price: yup.number().required().min(0),
    //     vat_percent: yup.number().required().min(0),
    //     with_vat: yup.number().required().min(0),
    //   })
    // )
    // .min(1, "At least one detail item is required")
    // .required(),


  }),
});


const import_lc_shipment_id = useField("import_lc_shipment_id");
const lc_id = useField("lc_id");
const currency_id = useField("currency_id");
const conversion_rate = useField("conversion_rate");
const date = useField("date");
const lc_value = useField("lc_value");
const lc_value_bdt = useField("lc_value_bdt");
const overhead_cost = useField("overhead_cost");
const remarks = useField("remarks");

const lc_issue_charge = useField("lc_issue_charge");
const freight_charge = useField("freight_charge");
const global_taxes = useField("global_taxes");
const insurance = useField("insurance");
const transportation_cost = useField("transportation_cost");
const c_and_f_expanse = useField("c_and_f_expanse");
const customs_duty = useField("customs_duty");
const total_lc_value = useField("total_lc_value");
const ait_percent = useField("ait_percent");
const profit_percent = useField("profit_percent");
const total_other_expanse = useField("total_other_expanse");
const total_qty = useField("total_qty");
const total_expanse = useField("total_expanse");
const vat_percent = useField("vat_percent");

lc_issue_charge.value.value = 0;
freight_charge.value.value = 0;
global_taxes.value.value = 0;
insurance.value.value = 0;
transportation_cost.value.value = 0;
c_and_f_expanse.value.value = 0;
customs_duty.value.value = 0;
ait_percent.value.value = 0;
profit_percent.value.value = 0;
vat_percent.value.value = 0;
conversion_rate.value.value = 0;
overhead_cost.value.value = 0;

const currency = ref(null);
const status = useField("status");
const details = ref([]);
const getLcShipmentList = ref([]);
const lc_costing_id = ref(null);
const is_freight_charge_auto = ref(true); 

const currentStatus = ref(0);
const selectedShipment = ref(null);

const total_qty_kgs = ref(0);
const total_value_gbp = ref(0);
const total_value_in_tk = ref(0);
const total_lc_issue_charge = ref(0);
const total_freight_charge = ref(0);
const total_global_taxes = ref(0);
const total_insurance = ref(0);
const total_transportation_cost = ref(0);
const total_c_and_f_expanse = ref(0);
const total_custom_duty = ref(0);
const total_lc_cost_per_kg = ref(0);
const total_landed_cost = ref(0);

const total_overhead = ref(0);
const total_product_cost = ref(0);
const total_profit = ref(0);
const total_sales_price = ref(0);
const total_ait = ref(0);
const total_price_with_ait = ref(0);
const total_vat = ref(0);
const total_with_vat = ref(0);



const onShipmentUpdate = async (newId) => {

  if (newId) { 
    const data = await store.dispatch("getLcImportLcShipmentById", newId);
    selectedShipment.value = data;

    currency.value = `(${selectedShipment.value.lc_master?.currency?.code})`;
    currency_id.value.value = selectedShipment.value.lc_master?.currency_id;
    details.value = selectedShipment.value?.shipment_items || [];
    lc_id.value.value = selectedShipment.value?.lc_id ?? null;
  } else {
    currency_id.value.value = null;
    details.value = [];
    lc_id.value.value = null;
  }
  calculateTotalExpanse();
};


const calculateTotalExpanse = () => {
  const total =
  Number(lc_issue_charge.value.value || 0) +
  Number(freight_charge.value.value || 0) +
  Number(global_taxes.value.value || 0) +
  Number(insurance.value.value || 0) +
  Number(transportation_cost.value.value || 0) +
  Number(c_and_f_expanse.value.value || 0) +
  Number(customs_duty.value.value || 0);

  total_other_expanse.value.value = total;

  total_expanse.value.value = Number(total_other_expanse.value.value ?? 0) + Number(lc_value_bdt.value.value ?? 0);

  calculateDetails();
}


const toTwo = (num) => Number(Number(num ?? 0).toFixed(2));

const safeNumber = (val) => {
  const num = Number(val);
  return toTwo(isNaN(num) ? 0 : num);
};

const calculateDetails = () => {

  let totalQty = 0;
  total_lc_value.value.value = 0;

  let totalLcValueBdt = 0;
  let totalLcValueUsd = 0;

  total_qty_kgs.value = 0;
  total_value_gbp.value = 0;
  total_value_in_tk.value = 0;
  total_lc_issue_charge.value = 0;
  total_freight_charge.value = 0;
  total_global_taxes.value = 0;
  total_insurance.value = 0;
  total_transportation_cost.value = 0;
  total_c_and_f_expanse.value = 0;
  total_custom_duty.value = 0;
  total_landed_cost.value = 0;
  total_lc_cost_per_kg.value = 0;
  total_overhead.value = 0;
  total_product_cost.value = 0;
  total_profit.value = 0;
  total_sales_price.value = 0;
  total_ait.value = 0;
  total_price_with_ait.value = 0;
  total_vat.value = 0;
  total_with_vat.value = 0;
  
  details.value.forEach((item, index) => {
    totalQty += Number(item.qty);

    if(route.params.id) item.import_lc_shipment_item_id = item.import_lc_shipment_item_id ?? null;
    else item.import_lc_shipment_item_id = item.id ?? null;

    item.total_value = toTwo(Number(item.qty) * Number(item.rate));
    item.value_in_tk = toTwo(item.total_value * Number(conversion_rate.value.value ?? 0));

    total_lc_value.value.value += item.value_in_tk;

    item.lc_issue_charge = toTwo(
      Number(item.total_value ?? 0) *
      (Number(lc_issue_charge.value.value ?? 0) / Math.max(Number(lc_value.value.value), 1))
    );

    item.hs_code = item.hs_code || item.proforma_invoice_detail?.hs_code || "";
    
    if (Number(is_freight_charge_auto.value)) {
      item.freight_charge = freight_charge.value.value
        ? toTwo(
            (Number(freight_charge.value.value ?? 0) / (Number(total_qty.value.value) ?? 1)) *
            Number(item.qty)
          )
        : 0;
    }

    item.custom_duty = toTwo(item.custom_duty ?? 0);

    item.global_taxes = toTwo(
      global_taxes.value.value
        ? (Number(global_taxes.value.value ?? 0) / (Number(total_qty.value.value) ?? 1)) * Number(item.qty)
        : 0
    );

    item.insurance = toTwo(
      insurance.value.value && lc_value.value.value
        ? (Number(insurance.value.value ?? 0) / (Number(lc_value.value.value) ?? 1)) * Number(item.total_value)
        : 0
    );

    item.transportation = toTwo(
      transportation_cost.value.value
        ? (Number(transportation_cost.value.value ?? 0) / (Number(total_qty.value.value) ?? 1)) * Number(item.qty)
        : 0
    );

    item.c_and_f_expense = toTwo(
      c_and_f_expanse.value.value
        ? (Number(c_and_f_expanse.value.value ?? 0) / (Number(total_qty.value.value) ?? 1)) * Number(item.qty)
        : 0
    );

    item.lc_cost_per_kg = toTwo(
      item.value_in_tk +
      item.lc_issue_charge +
      item.freight_charge +
      item.custom_duty +
      item.global_taxes +
      item.insurance +
      item.transportation +
      item.c_and_f_expense
    );

    item.landed_cost_per_kg = toTwo(item.lc_cost_per_kg / (item.qty || 1));

    item.overhead_cost_per_kg = toTwo(
      item.landed_cost_per_kg * ((overhead_cost.value.value ?? 0) / 100)
    );

    item.product_cost_per_kg = toTwo(
      item.landed_cost_per_kg + item.overhead_cost_per_kg
    );

    item.profit_per_kg = toTwo(
      item.product_cost_per_kg * Number(profit_percent.value.value ?? 0) / 100
    );

    item.sales_price = toTwo(
      item.product_cost_per_kg + item.profit_per_kg
    );

    item.ait_per_kg = toTwo(
      item.sales_price * ((Number(ait_percent.value.value) ?? 0) / 100)
    );

    item.price_with_ait = toTwo(
      item.sales_price + item.ait_per_kg
    );

    item.vat_per_kg = toTwo(
      item.price_with_ait * ((Number(vat_percent.value.value) ?? 0) / 100)
    );

    item.with_vat = toTwo(
      item.price_with_ait + item.vat_per_kg
    );

    totalLcValueBdt += item.value_in_tk;
    totalLcValueUsd += item.total_value;

    total_qty_kgs.value = totalQty;
    total_value_gbp.value = totalLcValueUsd;
    total_value_in_tk.value = totalLcValueBdt;

    total_lc_issue_charge.value += safeNumber(item.lc_issue_charge);
    total_freight_charge.value += safeNumber(item.freight_charge);
    total_global_taxes.value += safeNumber(item.global_taxes);
    total_insurance.value += safeNumber(item.insurance);
    total_transportation_cost.value += safeNumber(item.transportation);
    total_c_and_f_expanse.value += safeNumber(item.c_and_f_expense);
    total_custom_duty.value += safeNumber(item.custom_duty);
    total_landed_cost.value += safeNumber(item.landed_cost_per_kg);
    total_lc_cost_per_kg.value += safeNumber(item.lc_cost_per_kg);

    total_overhead.value += safeNumber(item.overhead_cost_per_kg);
    total_product_cost.value += safeNumber(item.product_cost_per_kg);
    total_profit.value += safeNumber(item.profit_per_kg);
    total_sales_price.value += safeNumber(item.sales_price);
    total_ait.value += safeNumber(item.ait_per_kg);
    total_price_with_ait.value += safeNumber(item.price_with_ait);
    total_vat.value += safeNumber(item.vat_per_kg);
    total_with_vat.value += safeNumber(item.with_vat);
  });

  lc_value.value.value = toTwo(totalLcValueUsd);
  lc_value_bdt.value.value = toTwo(totalLcValueBdt);
  total_qty.value.value = totalQty;

};

const removeDetailRow = (index) => {
  details.value.splice(index, 1);
};

const submitForm = (btnStatus) => {
  currentStatus.value = btnStatus;
  status.value.value = btnStatus;
  submit();
};

const submit = handleSubmit(async (values) => {
  try {
    let Payload = {
      lc_id: lc_id.value.value,
      lc_costing_id:lc_costing_id.value,
      import_lc_shipment_id: import_lc_shipment_id.value.value,
      date: date.value.value,
      currency_id: currency_id.value.value,
      lc_value: lc_value.value.value,
      lc_value_bdt: lc_value_bdt.value.value,
      overhead_cost: overhead_cost.value.value,
      ait_percent: ait_percent.value.value,
      profit_percent: profit_percent.value.value,
      vat_percent: vat_percent.value.value,
      conversion_rate: conversion_rate.value.value,
      remarks: remarks.value.value,

      lc_issue_charge: lc_issue_charge.value.value,
      is_freight_charge_auto: is_freight_charge_auto.value,
      freight_charge: freight_charge.value.value,
      c_and_f_expanse: c_and_f_expanse.value.value,
      global_taxes: global_taxes.value.value,
      insurance: insurance.value.value,
      transportation_cost: transportation_cost.value.value,
      customs_duty: customs_duty.value.value,
      total_other_expanse: total_other_expanse.value.value,
      total_lc_value: total_lc_value.value.value,
      total_qty: total_qty.value.value,
      total_expanse: total_expanse.value.value,

      status: status.value.value,

      details: details.value,
    };
    
    store.commit("SET_LOADING", { color: "primary" });
    await store.dispatch('saveUpdateLcImportLcCosting', Payload);
    store.commit("UNSET_LOADING");
    toast.success(status.value.value === 0 ? "LC Costing saved as draft successfully" : "LC Costing posted successfully");
    router.push({ name: 'lc-import-lc-costing-records' });

    toast.success("LC Costing saved successfully! (Replace with API call)");
  } catch (err) {
    store.commit("UNSET_LOADING");
    toast.error("Failed to save LC Costing");
  }
});

const loadExistingData = async () => {
  if (route.params.id) {
    try {
      await store.dispatch("getLcImportLcCostingById", route.params.id);
      const costingData = store.getters.getEditingLcImportLcCosting;
      
      if (costingData) {
        //console.log(costingData);

        lc_costing_id.value = costingData.id;
        lc_id.value.value = costingData.lc_id;
        import_lc_shipment_id.value.value = costingData.import_lc_shipment_id;
        currency_id.value.value = costingData.currency_id;

        conversion_rate.value.value = parseFloat(costingData.conversion_rate || 0);
        date.value.value = costingData.date;
        remarks.value.value = costingData.remarks;

        lc_value.value.value = parseFloat(costingData.lc_value || 0);
        lc_value_bdt.value.value = parseFloat(costingData.lc_value_bdt || 0);
        total_lc_value.value.value = parseFloat(costingData.total_lc_value || 0);

        lc_issue_charge.value.value = parseFloat(costingData.lc_issue_charge || 0);
        freight_charge.value.value = parseFloat(costingData.freight_charge || 0);
        global_taxes.value.value = parseFloat(costingData.global_taxes || 0);
        insurance.value.value = parseFloat(costingData.insurance || 0);
        transportation_cost.value.value = parseFloat(costingData.transportation_cost || 0);
        c_and_f_expanse.value.value = parseFloat(costingData.c_and_f_expanse || 0);
        customs_duty.value.value = parseFloat(costingData.customs_duty || 0);

        total_other_expanse.value.value = parseFloat(costingData.total_other_expanse || 0);
        total_qty.value.value = parseFloat(costingData.total_qty || 0);
        total_expanse.value.value = parseFloat(costingData.total_expanse || 0);

        ait_percent.value.value = parseFloat(costingData.ait_percent || 0);
        profit_percent.value.value = parseFloat(costingData.profit_percent || 0);
        vat_percent.value.value = parseFloat(costingData.vat_percent || 0);
        overhead_cost.value.value = parseFloat(costingData.overhead_cost || 0);

        is_freight_charge_auto.value = !!costingData.is_freight_charge_auto;

        lc_costing_id.value = costingData.id;
        lc_id.value.value = costingData.lc_id;
        conversion_rate.value.value = parseFloat(costingData.conversion_rate);
        date.value.value = costingData.date;
        remarks.value.value = costingData.remarks;
        currency_id.value.value = costingData.currency_id; 
        details.value = costingData.details;
        console.log("CKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK");
        console.log(costingData.lc_master);
        getLcShipmentList.value =  [costingData.shipment];
        import_lc_shipment_id.value.value = costingData.shipment?.id;
      }
    } catch (error) {
      toast.error("Failed to load costing data");
    } finally {
    }
  }
};

onMounted(async () => {
  store.commit("SET_LOADING", { color: "primary" });
  await store.dispatch('getCurrencyList');
  await store.dispatch("getProductMapList", {});
  await store.dispatch("getLcImportLcMasterList", {});

  if (route.params.id) {
    await loadExistingData();
  } else {
    await store.dispatch('getLcImportLcShipmentList',{type: 'shipments_for_costing'});
    getLcShipmentList.value = store.getters.getLcImportLcShipmentList || [];
  }
  store.commit("UNSET_LOADING");

});
</script>

<style>
.no-wrap-table th {
  position: sticky !important;
  top: 0 !important;
  background: white !important;
  z-index: 10 !important;
}
</style>